import api from '@/api/api';
import { createQueryParams } from '@/utils/createQueryParams';

const DOMAIN = '/clinic';

const get = async (
	params: Clinics.ClinicParams,
): Promise<Clinics.GetClinicsRespose> => {
	const queryParams = createQueryParams({ ...params });
	const { data } = await api.get(`${DOMAIN}?${queryParams}`);

	return data;
};

const getById = async (id: string): Promise<Clinics.ClinicDetail> => {
	const { data } = await api.get(`${DOMAIN}/${id}?include_address=true`);
	return data;
};

const create = async (body: Clinics.Create): Promise<void> => {
	await api.post(`${DOMAIN}/with-address`, body);
};

const patch = async (body: Partial<Clinics.Create>): Promise<void> => {
	await api.patch(`${DOMAIN}/with-address`, body);
};

const ClinicService = {
	get,
	getById,
	create,
	patch,
};

export { ClinicService };
